module.exports = __webpack_public_path__ + "static/media/left-arrow-icon (1).4919a563.svg";